// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { MessageFrontend as createMessageFrontendConfluenceCreateASpace } from '@post-office/message-template--confluence-create-a-space/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluenceResurrectedUserWelcomeSideBarNudge } from '@post-office/message-template--confluence-resurrected-user-welcome-sidebar-nudge/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluenceSideNav1On1LoomNudge } from '@post-office/message-template--confluence-side-nav-1-on-1-loom-nudge/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluenceSideNavCreateASpace } from '@post-office/message-template--confluence-side-nav-create-a-space/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluenceCreateWithRovoSideNavNudge } from '@post-office/message-template--confluence-create-with-rovo-side-nav-nudge/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendRovoExtensionInstallCta } from '@post-office/message-template--rovo-extension-install-cta-left-nav/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendTwcSidenavBanner } from '@post-office/message-template--twc-sidenav-banner/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendTwcSidenavAaBanner } from '@post-office/message-template--twc-sidenav-a-a-banner/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluenceRovoOnboardingBanner } from '@post-office/message-template--confluence-rovo-onboarding-banner/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluence3pToolsNudgeBanner } from '@post-office/message-template--confluence-3p-tools-nudge-banner/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendRovoNonMauChatCtaJiraConfluenceLeftNav } from '@post-office/message-template--rovo-non-mau-chat-cta-jira-confluence-left-nav/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluenceAgentsMcpNudgeBanner } from '@post-office/message-template--confluence-agents-mcp-nudge-banner/placements/in-app-v2/confluence-side-nav';

import { MessageFrontend as createMessageFrontendTwcLoomMeetingNudgeSidenav } from '@post-office/message-template--twc-loom-meeting-nudge-sidenav/placements/in-app-v2/confluence-side-nav'

import {
	PlacementFrontend,
	type PlacementFrontendProps,
} from '@post-office/placements--growth/confluence-side-nav';

import { type PlacementRendererStage } from '@post-office/placement-common-v2/create-placement/types';

const messageFrontends = [
	createMessageFrontendConfluenceCreateASpace({ messageTemplateId: 'confluence-create-a-space' }),
	createMessageFrontendConfluenceSideNavCreateASpace({
		messageTemplateId: 'confluence-side-nav-create-a-space',
	}),
	createMessageFrontendConfluenceSideNav1On1LoomNudge({
		messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge',
	}),
	createMessageFrontendConfluenceResurrectedUserWelcomeSideBarNudge({
		messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge',
	}),
	createMessageFrontendConfluenceCreateWithRovoSideNavNudge({
		messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge',
	}),
	createMessageFrontendRovoExtensionInstallCta({
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
	}),
	createMessageFrontendTwcSidenavBanner({ messageTemplateId: 'twc-sidenav-banner' }),
	createMessageFrontendTwcSidenavAaBanner({
		 messageTemplateId: 'twc-sidenav-a-a-banner' }),
	createMessageFrontendConfluenceRovoOnboardingBanner({
		messageTemplateId: 'confluence-rovo-onboarding-banner',
	}),
	createMessageFrontendConfluence3pToolsNudgeBanner({
		messageTemplateId: 'confluence-3p-tools-nudge-banner',
	}),
	createMessageFrontendRovoNonMauChatCtaJiraConfluenceLeftNav({
		messageTemplateId: 'rovo-non-mau-chat-cta-jira-confluence-left-nav',
	}),
	createMessageFrontendConfluenceAgentsMcpNudgeBanner({
		messageTemplateId: 'confluence-agents-mcp-nudge-banner',
	}),
	createMessageFrontendTwcLoomMeetingNudgeSidenav({
		messageTemplateId: 'twc-loom-meeting-nudge-sidenav',
	})
];

export const Placement: PlacementRendererStage<PlacementFrontendProps> = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});
